<template>
    <footer class="footer-section  py-4 md:px-8">
        <div class="container text-center px-4 md:px-6">

            <div class="flex justify-content-center mb-2">
                <img src="@/assets/footerLogo.png" alt="ILearn'd Tutors Logo" class="h-5rem md:h-6rem" />
            </div>
            <div class="grid mb-2">
                <div class="col-12 md:col-6 lg:col-3  justify-content-center flex">
                    <div class="footer-column text-left ">
                        <h4 class="H6-Medium text-white mb-3 ">About Us</h4>
                        <ul class="list-none p-0 m-0 space-y-2">
                            <li><router-link to="/aboutUs" class="text-gray-300 Label hover:text-white no-underline transition-colors">Who we
                                    are</router-link></li>
                            <li><router-link to="/#how-it-works" class="text-gray-300 Label hover:text-white no-underline transition-colors">How it
                                    works</router-link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="col-12 md:col-6 lg:col-3 justify-content-center flex">
                    <div class="footer-column text-left">
                        <h4 class="H6-Medium text-white mb-3">For Tutors</h4>
                        <ul class="list-none p-0 m-0 space-y-2">
                            <li><router-link to="/becomeTutor" class="text-gray-300 Label hover:text-white no-underline transition-colors">Become
                                    an online
                                    tutor</router-link></li>
                        </ul>
                    </div>
                </div>

                <div class="col-12 md:col-6 lg:col-3 justify-content-center flex">
                    <div class="footer-column text-left">
                        <h4 class="H6-Medium text-white mb-3">Contact Us</h4>
                        <ul class="list-none p-0 m-0 space-y-2">
                            <li><router-link to="/aboutUs#contact-us" class="text-gray-300 hover:text-white Label no-underline transition-colors">Customer
                                    support</router-link></li>
                        </ul>


                    </div>
                </div>

                <div class="col-12 md:col-6 lg:col-3 justify-content-center flex">
                    <div class="footer-column text-left">
                        <h4 class="H6-Medium text-white mb-3">Social Media</h4>
                        <div class="flex gap-2 align-items-center justify-content-center">
                            <a href="https://www.facebook.com/profile.php?id=61590485003033" target="_blank" class=" rounded-full flex items-center justify-center no-underline ">
                                <i class="pi pi-facebook text-white"></i>
                            </a>
                            <a href="https://www.instagram.com/ilearnd_tutors/" target="_blank" class=" rounded-full flex items-center justify-center no-underline ">
                                <i class="pi pi-instagram text-white"></i>
                            </a>
                            <a href="https://www.tiktok.com/@ilearnd.tutors?_r=1&_t=ZS-96Lc4ffEOe5" target="_blank" class=" rounded-full flex items-center justify-center no-underline ">
                                <i class="pi pi-tiktok text-white"></i>
                            </a>
                            <a href="https://www.linkedin.com/company/ilearnd-d-tutors/" target="_blank" class="  rounded-full flex items-center justify-center no-underline ">
                                <i class="pi pi-linkedin text-white"></i>
                            </a>
                        </div>
                    </div>
                </div>


            </div>
            <div class="col-12">
                <div class="footer-column">
                    <p class="text-gray-300 Label hover:text-white transition-colors mb-1">Ilearn'd Tutors Pvt
                        Ltd</p>
                    <div class="flex flex-wrap justify-content-center items-center">
                        <ul class="list-none p-0 m-0 flex flex-wrap gap-4">
                            <li><router-link to="/legal-center" 
                                class="text-gray-300 Caption hover:text-white no-underline transition-colors">Legal
                                     Center</router-link></li>
                            <li><router-link to="/privacy-policy"
                                    class="text-gray-300 hover:text-white Caption no-underline transition-colors">Privacy
                                    Policy</router-link></li>
                            <li><router-link to="/termsOfService"
                                    class="text-gray-300 hover:text-white Caption no-underline transition-colors">Terms of Service</router-link></li>
                            <li><router-link to="/privacy-policy#cookie-policy" class="text-gray-300 hover:text-white Caption no-underline transition-colors">Cookie
                                    Policy</router-link></li>
                            <li><router-link to="/legal-notice" class="text-gray-300 hover:text-white Caption no-underline transition-colors">Legal
                                    Notice</router-link></li>
                        </ul>
                    </div>
                </div>
            </div>

        </div>
    </footer>
</template>
<style scoped>
.footer-section {
    background-color: #272727;
}
</style>